import { render, staticRenderFns } from "./setpassword.vue?vue&type=template&id=fd7ed306&scoped=true"
import script from "./setpassword.vue?vue&type=script&lang=js"
export * from "./setpassword.vue?vue&type=script&lang=js"
import style0 from "./setpassword.vue?vue&type=style&index=0&id=fd7ed306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7ed306",
  null
  
)

export default component.exports